import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar'
import { useDispatch, useSelector } from 'react-redux';
import { getTutorViewAssDetail } from '../../../../../../Redux/action/TutorAction';
import Beatloader from '../../../../../../Common/BeatLoader';

const host = process.env.REACT_APP_API_SERVER
const TutorViewAssessmentObjectiveTest = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { b64id } = useParams();

    useEffect(() => {
        try {

            let assessment_id = atob(b64id);

            if (!assessment_id || isNaN(assessment_id)) {
                throw new Error("Invalid course ID");
            }

            dispatch(getTutorViewAssDetail(assessment_id))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);

    const {
        loadingTutorViewAssDetailApi,
        TutorViewAssDetailApiData,
        TutorViewAssDetailApiError

    } = useSelector(state => state?.TutorReducer);

    console.log(TutorViewAssDetailApiData)


    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Objective Test
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="add-new-course-sec">
                                    <h4 className="mb-4">Add Questions</h4>
                                    <div className="card bg-light">
                                        {loadingTutorViewAssDetailApi ?
                                            <Beatloader />
                                            :
                                            <div className="card-body">
                                                <div id="session-container">
                                                    {/* First session is added here by default */}
                                                    {TutorViewAssDetailApiData?.objective_questions?.length > 0 ?
                                                        TutorViewAssDetailApiData?.objective_questions?.map((data, index) => (
                                                            <div className="session mb-4" id="session-1">
                                                                <div className="row mb-3">
                                                                    <div className="col-lg-12">
                                                                        <div className="input-group d-flex justify-content-between">
                                                                            <div>
                                                                                <h6 className="mb-3">Question-{index + 1}</h6>
                                                                            </div>
                                                                            <div>
                                                                                <input
                                                                                    type="number"
                                                                                    className="input-card-form"
                                                                                    placeholder="Marks for question - 1"
                                                                                    readOnly
                                                                                    value={data?.marks}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-12">
                                                                        <div className="input-group">
                                                                            <textarea
                                                                                className="input-card-form"
                                                                                placeholder="Write Question"
                                                                                readOnly
                                                                                defaultValue={data?.title}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-1 col-md-1 col-2 pe-0">
                                                                            <h6 className="mb-0 fw-bold mt-2">A.</h6>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-11 col-10 ps-0">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="input-card-form"
                                                                                    placeholder="Write Option A"
                                                                                    readOnly
                                                                                    value={data?.first_option}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-1 col-md-1 col-2 pe-0">
                                                                            <h6 className="mb-0 fw-bold mt-2">B.</h6>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-11 col-10 ps-0">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="input-card-form"
                                                                                    placeholder="Write Option B"
                                                                                    readOnly
                                                                                    value={data?.second_option}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-1 col-md-1 col-2 pe-0">
                                                                            <h6 className="mb-0 fw-bold mt-2">C.</h6>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-11 col-10 ps-0">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="input-card-form"
                                                                                    placeholder="Write Option C"
                                                                                    readOnly
                                                                                    value={data?.third_option}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-1 col-md-1 col-2 pe-0">
                                                                            <h6 className="mb-0 fw-bold mt-2">D.</h6>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-11 col-10 ps-0">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="input-card-form"
                                                                                    placeholder="Write Option D"
                                                                                    readOnly
                                                                                    value={data?.fourth_option}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-8">
                                                                            <div className="card">
                                                                                <div className="card-body">
                                                                                    <h6 className="text-primary">Answer - {index + 1}</h6>
                                                                                    <div className="row">
                                                                                        {["first_option", "second_option", "third_option", "fourth_option"].map((optionKey, idx) => (
                                                                                            <div className="col-lg-2 col-md-6 col-6" key={optionKey}>
                                                                                                <span className="fw-bold">{String.fromCharCode(65 + idx)}</span>&nbsp;&nbsp;
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    className="form-check-input"
                                                                                                    name={`options-${index}`} // Unique name for each question
                                                                                                    checked={data?.correct_option === optionKey}
                                                                                                    readOnly
                                                                                                />
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>
                                                    }
                                                </div>
                                            </div>}
                                    </div>

                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorViewAssessmentObjectiveTest